import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { range, sample } from 'lodash'

import 'modules/ats/pages/JobPostingMarketplace/index.styles.css'

export const PremiumProductCardSkeleton = () => {
  return (
    <Box className={'JobPostingMarketplace_premiumOfferCardStyle'}>
      <Box padding="s16" gap="s8" flexDirection="row" alignItems="center">
        <Box borderRadius={{ all: 'rel1000' }} overflowX="hidden">
          <Skeleton width="s40" height="s40" />
        </Box>
        <Skeleton width={sample(['s300', 's240', 's200'])} height="s16" />
      </Box>
      {range(3).map((index) => (
        <Box
          key={`product-card-skeleton-subproduct-${index}`}
          padding="s16"
          gap="s12"
          flexDirection="row"
          justifyContent="spaceBetween"
          alignItems="center"
          border={{
            top: {
              color: 'grey400',
              width: 's1',
              style: 'solid',
            },
          }}
        >
          <Box flexDirection="row" gap="s8">
            <Skeleton width={sample(['s120', 's96', 's140'])} height="s16" />
            <Skeleton width="s64" height="s16" />
          </Box>
          <Skeleton width="s64" height="s32" />
        </Box>
      ))}
    </Box>
  )
}
